import { forwardRef } from 'react';
import { Radio } from '@radix-ui/themes';
import type { RadixRadioProps } from '@/types/radix-ui';

/**
 * Radio component - wrapper around Radix UI Radio
 * Provides all functionality of the original component while allowing
 * for centralized customization and future extensions.
 */

export type RadioProps = RadixRadioProps;

const UIRadio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  return <Radio ref={ref} {...props} />;
});

UIRadio.displayName = 'Radio';

export { UIRadio as Radio };
